module.exports = __webpack_public_path__ + "img/1.47257748.png";